<template>
  <div class="relative">
    <select
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      :id="'form_' + name"
      :value="value"
      :name="name"
      class="peer inline-flex w-full cursor-pointer appearance-none items-center rounded disabled:pointer-events-none h-11 pe-8 ps-3"
      :class="[{ 'uk-form-danger': error }, 'w-full']"
    >
    <option value="" disabled>{{ $attrs.placeholder ? $attrs.placeholder : 'Bitte wählen' }}</option>
    <option :value="option.value" v-for="(option, index) in options" :key="index">{{ option.label }}</option>
    </select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  inject: ['$validator'],
  inheritAttrs: false,
  props: {
    value: {
      required: false,
      Type: String,
      default: ''
    },
    name: {
      required: true,
      Type: String
    },
    options: {
      required: true,
      Type: Array
    },
    width: {
      required: false,
      type: String,
      default: '1-1'
    },
    error: {
      type: String,
      default: null
    }
  },
  components: {
    vSelect
  }
}
</script>
